import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Film } from 'lucide-react';

export const LoginPage = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(identifier, password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden" style={{ backgroundColor: '#0F171E' }}>
      {/* Background gradient effect */}
      <div className="absolute inset-0 opacity-30" style={{
        background: 'radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.15), transparent 50%), radial-gradient(circle at 80% 30%, rgba(59, 130, 246, 0.1), transparent 50%)'
      }}></div>

      <div className="w-full max-w-md p-8 rounded-2xl relative z-10" style={{ backgroundColor: '#1A2632', border: '1px solid #2A3F52' }}>
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-lg flex items-center justify-center mb-4" style={{ backgroundColor: '#1E3A8A' }}>
            <Film size={32} color="white" />
          </div>
          <h1 className="text-3xl font-bold" style={{ color: '#FFFFFF' }}>
            My<span style={{ color: '#3B82F6' }}>flix</span>
          </h1>
          <p className="text-sm mt-2" style={{ color: '#8197A4' }}>Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="p-4 rounded-lg" style={{ backgroundColor: 'rgba(220, 38, 38, 0.1)', border: '1px solid #DC2626' }} data-testid="login-error-message">
              <p className="text-sm" style={{ color: '#EF4444' }}>{error}</p>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: '#DDDDDD' }}>Membership ID</label>
            <input
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="w-full px-4 py-3 rounded-lg outline-none focus:ring-2"
              style={{ backgroundColor: '#0F171E', border: '1px solid #2A3F52', color: '#FFFFFF' }}
              required
              placeholder="e.g. MEMSAMPLE01"
              data-testid="login-email-input"
            />
            <p className="text-xs mt-2" style={{ color: '#8197A4' }}>
              Members: sign in with your Membership ID.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: '#DDDDDD' }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-lg outline-none focus:ring-2"
              style={{ backgroundColor: '#0F171E', border: '1px solid #2A3F52', color: '#FFFFFF' }}
              required
              data-testid="login-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg font-semibold transition-all duration-200 hover:scale-[1.02]"
            style={{ backgroundColor: '#1E3A8A', color: 'white' }}
            data-testid="login-submit-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-sm text-center mt-6" style={{ color: '#8197A4' }}>
          Don't have an account? Contact your administrator.
        </p>
      </div>
    </div>
  );
};
